<template>
  <div style="margin-bottom: 20px;">
    <table style="border-collapse:collapse; text-align: center; border-color: black; width: 100%" cellspacing="0" cellpadding="5" border="1">
            <tbody><tr>
                <td style="background: #F2F2F2;"></td>
                <td style="border-color: black; background: black; color: #FFFFFF;">Draw</td>
                <td style="background: #FFF2CC;">WC Regular</td>
                <td style="background: #FFF2CC;">WC Top 20</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">TOTAL Direct In</td>
                <td style="background: #F7CAAC;">Advanced Direct In (Doubles Rank)</td>
                <td style="background: #CCCCFF;">On-Site Direct In (Best Singles or DoublesRank)</td>
            </tr>
            <tr>
                <td rowspan="5" style="background: #F2F2F2;">WTA 250/500/1000</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">32</td>
                <td style="background: #FFF2CC;">2</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">29</td>
                <td style="background: #F7CAAC;">24</td>
                <td style="background: #CCCCFF;">5</td>
            </tr>
            <tr>
                <td style="border-color: black; background: black; color: #FFFFFF;">30</td>
                <td style="background: #FFF2CC;">2</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">27</td>
                <td style="background: #F7CAAC;">22</td>
                <td style="background: #CCCCFF;">5</td>
            </tr>
            <tr>
                <td style="border-color: black; background: black; color: #FFFFFF;">28</td>
                <td style="background: #FFF2CC;">2</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">25</td>
                <td style="background: #F7CAAC;">20</td>
                <td style="background: #CCCCFF;">5</td>
            </tr>
            <tr>                
                <td style="border-color: black; background: black; color: #FFFFFF;">24</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">22</td>
                <td style="background: #F7CAAC;">18</td>
                <td style="background: #CCCCFF;">4</td>
            </tr>
            <tr>
                <td style="border-color: black; background: black; color: #FFFFFF;">16</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">14</td>
                <td style="background: #F7CAAC;">11</td>
                <td style="background: #CCCCFF;">3</td>
            </tr>
            <tr>
                <td style="background: #F2F2F2;" rowspan="2">WTA 125</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">16</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="background: #FFF2CC;">0</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">15</td>
                <td style="background: #F7CAAC;">11</td>
                <td style="background: #CCCCFF;">4</td>
            </tr>
            <tr>
                <td style="border-color: black; background: black; color: #FFFFFF;">8</td>
                <td style="background: #FFF2CC;">1</td>
                <td style="background: #FFF2CC;">0</td>
                <td style="border-color: black; background: black; color: #FFFFFF;">7</td>
                <td style="background: #F7CAAC;">4</td>
                <td style="background: #CCCCFF;">3</td>
            </tr>
        </tbody></table>
  </div>
</template>

<style scoped>
</style>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// src/widgets/DrawSizeHeader.vue